{
  "pageTitle": "Analytics",
  "pageDescription": "Overview of your invoicing analytics",
  "totalInvoices": "Total Invoices",
  "totalPaid": "Total Paid",
  "pending": "Pending",
  "avgMonthly": "Avg Monthly",
  "monthlySpending": "Monthly Spending",
  "spendingByProvider": "Spending by Provider",
  "invoiceStatusDistribution": "Invoice Status Distribution",
  "spendingByAddress": "Spending by Address"
}
